module.exports = __webpack_public_path__ + "static/media/floating-phone.f73dae2d.gif";